import {Component, Input, OnInit} from '@angular/core';
import {
  AmountStatus,
  ApplicationFormSettings,
  Competitor,
  CompetitorViewContext,
  CompetitorViewData,
  CompetitorViewDataAvailableFields,
  CompetitorViewHelper,
  Country,
  EventItem,
  Lookups,
  Race,
  RaceAdditionalPricingItem,
  RaceCommercialItem, RaceRegistration,
  RaceSettings,
  RegistrationStatus,
  UserEvent,
  isFinishedEvent,
  Waypoint
} from "@model";
import {TranslocoService} from "@ngneat/transloco";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {AbstractComponent, MyEntryQrCodesModalComponent} from "@components";
import {
  EVENT_DETAILS,
  MY_ENTRY_PERSONAL_INFO,
  MY_ORDER_COMPLETE_PAYMENT,
  MY_TRACEY_UPCOMING,
  PRIVATE_EVENT_CALENDAR_ROUTE,
} from "src/app/app-routing.module";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-my-entry',
  templateUrl: './my-entry.component.html',
  styleUrl: './my-entry.component.scss',
  standalone: false
})
export class MyEntryComponent extends AbstractComponent implements OnInit {
  @Input() userEvent: UserEvent | undefined;
  @Input() countries: Country[] = [];
  @Input() languages: Lookups[] = [];

  isFinishedEvent = false;

  race: Race | undefined;
  event: EventItem | undefined;
  competitor: Competitor | undefined;
  teamMember: Competitor | undefined;
  isRegistrationOwner: boolean | undefined = false;

  startWaypoint: Waypoint | undefined;
  finishWaypoint: Waypoint | undefined;

  daysRemaining: number | undefined;
  paymentCompleted: boolean = false;

  amountStatus: AmountStatus = AmountStatus.NOT_PAID;
  registrationConfirmed: boolean = false;
  dropdownOpened: string | null = null;

  competitorFields?: CompetitorViewDataAvailableFields;
  teamMemberFields?: CompetitorViewDataAvailableFields;

  private viewDataHelper?: CompetitorViewHelper;

  competitorViewData: CompetitorViewData = new CompetitorViewData();
  teamMemberViewData?: CompetitorViewData;
  onlinePayment:boolean = false;

  startAndFinishEqual: boolean = true;

  private static readonly IGNORED_COLUMN_KEYS: (keyof CompetitorViewData)[] = [
    'paymentStatus', 'startNumber', 'startBlock', 'countryShort'
  ];

  constructor(public translocoService: TranslocoService, private modalService: NgbModal, private router: Router, private route: ActivatedRoute) {
    super();
  }

  ngOnInit(): void {
    if (this.userEvent?.event) {
      this.isFinishedEvent = isFinishedEvent(this.userEvent?.event);
    }
    this.initializeData();
    this.buildViewModels();
  }


  initializeData() {
    if (!this.userEvent) return;


    this.race = this.userEvent.race;
    this.event = this.userEvent.event;
    this.competitor = this.userEvent.competitor;
    this.isRegistrationOwner = !!this.userEvent.isOwner;
    this.teamMember = this.userEvent.teamMember;
    this.startWaypoint = this.userEvent.start;
    this.finishWaypoint = this.userEvent.finish;
    this.amountStatus = RaceRegistration.getAmountStatus(this.userEvent.raceRegistration);
    this.onlinePayment = !!this.userEvent.raceRegistration?.wsPayFormUrl;

    if (this.race?.raceStart) {
      this.daysRemaining = this.getDaysUntil(this.race.raceStart);
    }

    this.paymentCompleted = this.userEvent.raceRegistration?.registrationStatus === RegistrationStatus.CONFIRMED;
    this.registrationConfirmed = this.userEvent.registrationStatus === RegistrationStatus.CONFIRMED;
    this.startAndFinishEqual = this.startWaypoint?.longitude === this.finishWaypoint?.longitude
        && this.startWaypoint?.latitude === this.finishWaypoint?.latitude
        && this.startWaypoint?.address === this.finishWaypoint?.address
        && this.startWaypoint?.city === this.finishWaypoint?.city
        && this.startWaypoint?.country === this.finishWaypoint?.country;
  }


  private buildViewModels(): void {
    const race = this.race;
    const event = this.event;
    const competitor = this.competitor;

    if (!race?.id || !event?.id || !competitor) return;
    if (!race.raceSettings || !race.applicationFormSettings || !event.paymentSettings) return;

    const raceId = race.id;

    this.viewDataHelper = new CompetitorViewHelper(
        event.id,
        this.translocoService,
        this.countries,
        new Map<number, ApplicationFormSettings>([[raceId, race.applicationFormSettings]]),
        event.paymentSettings,
        new Map<number, RaceSettings>([[raceId, race.raceSettings]]),
        new Map<number, RaceCommercialItem[]>(),
        new Map<number, RaceAdditionalPricingItem[]>(),
        CompetitorViewContext.COMPETITOR_SELF,
        false,
        new Map<number, Race>([[raceId, race]]),
        race
    );

    const raceFields = this.viewDataHelper.viewDataByRaceIds.get(raceId);
    this.competitorFields = raceFields;

    if (raceFields) {
      this.viewDataHelper.selectAllExcept(raceFields, MyEntryComponent.IGNORED_COLUMN_KEYS);
    }

    this.competitorViewData = this.viewDataHelper.competitorToCompetitorViewData(competitor);

    if (raceFields?.teamMemberView && this.teamMember) {
      this.teamMemberFields = raceFields.teamMemberView;
      this.teamMemberViewData = this.viewDataHelper.competitorToCompetitorViewData(this.teamMember, false);

      this.viewDataHelper.selectAllExcept(this.teamMemberFields, MyEntryComponent.IGNORED_COLUMN_KEYS);
    }
  }





  getDaysUntil(date: string | Date): number {
    const raceDate = new Date(date);
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    raceDate.setHours(0, 0, 0, 0);

    const diffInMs = raceDate.getTime() - today.getTime();

    const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

    return diffInDays > 0 ? diffInDays : 0;
  }

  openAllAddOns(){

  }

  goToCompletePayment(): void {
    // if (this.userEvent?.raceRegistration)
    // this.router.navigate([MY_ORDER_COMPLETE_PAYMENT], {
    //   relativeTo: this.route,
    //   queryParams: {orderId : this.userEvent.raceRegistration!.id!},
    //   queryParamsHandling: "merge"
    // });
  }

  goToOrder(race: any) {
    // this.router.navigate([ORDER_DETAILS], {
    //   queryParams: {orderId: race.id,}
    // });
  }

  openPersonalInfo() {
    this.router.navigate([MY_ENTRY_PERSONAL_INFO], {
      relativeTo: this.route,
    });
  }

  openQrCodesModal() {
    const modalRef = this.modalService.open(MyEntryQrCodesModalComponent, {
      centered: true,
      windowClass: 'my-entry-qr-codes-modal'
    });

    modalRef.componentInstance.event = this.event;
    modalRef.componentInstance.race = this.race;
    modalRef.componentInstance.registrationConfirmed = this.registrationConfirmed;
    modalRef.componentInstance.languages = this.languages;
    modalRef.componentInstance.countries = this.countries;
  }

  toggleDropdown(type: string) {
    if(type === 'qrcodes') {
      this.openQrCodesModal();
    } else if(type === 'orders'){
      this.goToOrder(this.race);
    } else {
      this.dropdownOpened = this.dropdownOpened === type ? null : type;
    }
  }

  goToEventDetailsPage(event: EventItem | undefined): void {
    if (event?.id) {
      ///todo fix routes!!!!
      this.router.navigate(
        [PRIVATE_EVENT_CALENDAR_ROUTE, EVENT_DETAILS],
        {
          queryParams: {
            eventId: event.id
          }
        }
      );
    }
  }

  keepOriginalOrder = () => 0;

  goBack() {
    this.router.navigate([MY_TRACEY_UPCOMING])
  }

  protected readonly RegistrationStatus = RegistrationStatus;
  protected readonly AmountStatus = AmountStatus;
}
